import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/babykraken_logotext-min.png";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";
import { ReactComponent as TelegramIcon } from "../../images/telegram.svg";
import { ReactComponent as GithubIcon } from "../../images/github.svg";


const Container = tw(ContainerBase)`bg-gray-200 text-black -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-auto`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-black hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoImg src={logo} />
          </LogoContainer>
          <LinksContainer>
            <Link href="https://www.kraken.baby">Home</Link>
            <Link href="https://docs.kraken.baby">Wiki</Link>
            <Link href="https://github.com/BabyKraken">Github</Link>
            <Link href="https://t.me/babykrakentoken">Telegram</Link>
            <Link href="https://twitter.com/BabyKrakenBSC">Twitter</Link>
            <Link href="#">PancakeSwap</Link>
          </LinksContainer>
          <SocialLinksContainer>
            <SocialLink href="https://t.me/babykrakentoken">
              <TelegramIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com/BabyKrakenBSC">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://github.com/BabyKraken">
              <GithubIcon />
            </SocialLink>
          </SocialLinksContainer>
        </Row>
      </Content>
    </Container>
  );
};
